import { useFrame, useThree } from '@react-three/fiber';
import { useRef } from 'react';
import { ECS } from '../state';
import { players } from '../queries';
import { beerConfig } from '@/config/games/beer';
import { Vector3, Frustum, Matrix4, Box3 } from 'three';
import { urls } from '@/config/assets';
import AssetService from '@/services/AssetService';

const movingEntities = ECS.world.with('position', 'velocity');
const meshEntities = ECS.world.with('three');

const onScreenTypes = ECS.world.with('onScreen', 'type', 'isObstacle');

export const SystemOnScreen = () => {
  const { camera, viewport } = useThree();
  const tempVector = useRef(new Vector3());
  const tempScreenPos = useRef(new Vector3());
  const frustum = useRef(new Frustum());
  const projScreenMatrix = useRef(new Matrix4());
  const tempBox = useRef(new Box3());

  useFrame(() => {
    // Update frustum with current camera matrices
    projScreenMatrix.current.multiplyMatrices(
      camera.projectionMatrix,
      camera.matrixWorldInverse
    );
    frustum.current.setFromProjectionMatrix(projScreenMatrix.current);

    // Check all entities with position and three components
    for (const entity of meshEntities) {
      if (!entity.position) continue;

      // Get entity world position and compute bounding box
      const entityPos = entity.three.position;
      const entityMesh = entity.three;

      // Compute bounding box for the entity
      tempBox.current.setFromObject(entityMesh);

      // Check if entity's bounding box intersects with camera frustum
      // This is more accurate than just checking the center point
      const onScreen = frustum.current.intersectsBox(tempBox.current);

      // Set the onScreen property on the entity
      if (onScreen && !entity.onScreen) {
        ECS.world.addComponent(entity, 'onScreen', true);
      } else if (!onScreen && entity.onScreen) {
        ECS.world.removeComponent(entity, 'onScreen');
      }
    }
  });

  useFrame(() => {
    const types = onScreenTypes.entities.map((entity) => entity.type);
    // const uniqueTypes = [...new Set(types)];
    let sfx = AssetService.getAsset('s_on_screen_wasps');
    if (!sfx) return;
    if (types.indexOf('wasps') != -1) {
      if (sfx.paused) sfx.play({ volume: 0 });
      sfx.fade(1, 200);
    } else {
      sfx.fade(0, 200);
    }
  });

  return null;
};
